export const PROCESSING_RULE_TYPE_KEY = 'processingRuleType';
import { TriggerCategoryType } from '@/modules/HealthPlan/HealthPlan.types.ts';

export interface MainInfo {
  name: string;
  [PROCESSING_RULE_TYPE_KEY]?: string;
}

export interface AddTriggerFormValues {
  triggerName: string;
  triggerType: TriggerCategoryType;
}
